import React from 'react';

import { accountListSelector, useAccounts } from '../../../../fetchHooks/useAccount';
import { useAccountsGroupsQuery } from '../../../../fetchHooks/useAccountsGroups';
import { useAccountsPropertiesQuery } from '../../../../fetchHooks/useAccountsProperties';
import useTranslation from '../../../../hooks/useTranslation';
import { simulateMissingGroups } from '../../../../services/accountsGroupsService';
import { ErrorView } from '../../../AccountOverview/components';
import { getGroupedAccounts } from '../../../EditAccountOverview/components/DragAndDropAccountsList/components/GroupedSortableDnd/components/DndContextProvider/utils';
import { AccountsOverviewContent } from '../AccountsOverviewContent';
import { AccountsOverviewLoader } from '../AccountsOverviewLoader';

export const GroupedAccountsList = () => {
    const translation = useTranslation();
    const accountsQuery = useAccounts({ select: accountListSelector });
    const groupsQuery = useAccountsGroupsQuery();
    const propertiesQuery = useAccountsPropertiesQuery();

    if (accountsQuery.error) {
        return <ErrorView error={accountsQuery.error} refresh={accountsQuery.refetch} />;
    }

    if (groupsQuery.error) {
        return <ErrorView error={groupsQuery.error} refresh={groupsQuery.refetch} />;
    }

    if (propertiesQuery.error) {
        return <ErrorView error={propertiesQuery.error} refresh={propertiesQuery.refetch} />;
    }

    if (
        accountsQuery.data === undefined ||
        groupsQuery.data === undefined ||
        propertiesQuery.data === undefined ||
        accountsQuery.isLoading ||
        groupsQuery.isLoading ||
        propertiesQuery.isLoading ||
        accountsQuery.isRefetching ||
        groupsQuery.isRefetching ||
        propertiesQuery.isRefetching
    ) {
        return <AccountsOverviewLoader accounts={accountsQuery.data} />;
    }

    const groupedAccounts = getGroupedAccounts(
        accountsQuery.data.map((it) => ({ ...it, id: it.accountNumber.value })),
        simulateMissingGroups(groupsQuery.data, translation.accountOverview.headingMobile),
        propertiesQuery.data,
    ).filter((group) => group.values.length !== 0);

    return (
        <>
            {groupedAccounts.map((group) => {
                return <AccountsOverviewContent key={group.id} accounts={group.values} header={group.name} />;
            })}
        </>
    );
};
